export const GDBREAKPOINTS_NUM = {
    XS: 375,
    SM: 480,
    MD: 768,
    LG: 1024,
    XL: 1280,
    XXL: 1440
};

export const MODAL_BREAKPOINT_NUM = 527;
export const ATBAT_MODAL_BREAKPOINT = MODAL_BREAKPOINT_NUM + 1 + 'px';
export const ATBAT_SHARE_MARGIN_BREAKPOINT = '501px';

export const MODAL_BREAKPOINT_MOBILE = MODAL_BREAKPOINT_NUM + 'px';
export const MODAL_BREAKPOINT_DESKTOP = MODAL_BREAKPOINT_NUM + 1 + 'px';
/*
Live View Types:
SingleColumnNarrow (mobile) :  <= XS_MAX,
SingleColumn : SM_MIN - SM_MID,
SingleColumnWide : SM_MID - SM_MAX,
TwoColumn: MD_MIN - MD_MAX,
ThreeColumnNarrow: LG_MIN - LG_MAX,
ThreeColumnFull: XL_MIN - XL_MAX,
ThreeColumnWide:  >= XXL_MIN
*/

const GDBREAKPOINTS_THRESHOLDS = {
    XS_MAX: 600,
    SM_MIN: 601,
    SM_REG_MAX: 767,
    SM_WIDE_MIN: 768,
    SM_MAX: 1023,
    MD_MIN: 1024,
    MD_MAX: 1279,
    LG_MIN: 1280,
    LG_MAX: 1365,
    XL_MIN: 1366,
    XL_MAX: 1919,
    XXL_MIN: 1920,
    FINAL_SM_MAX: 767,
    FINAL_MD_MIN: 768,
    FINAL_MD_MAX: 1023,
    FINAL_LG_MIN: 1024,
    FINAL_MINI_XS_MAX: 480,
    FINAL_MINI_SM_MAX: 600,
    LIVE_MINI_XS_MAX: 480,
    LIVE_MINI_SM_MAX: 600,
    LIVE_MINI_MD_MIN: 601
};

export const GDBREAKPOINTS_FINAL = {
    SM_MAX: GDBREAKPOINTS_THRESHOLDS.FINAL_SM_MAX + 'px',
    MD_MIN: GDBREAKPOINTS_THRESHOLDS.FINAL_MD_MIN + 'px',
    MD_MAX: GDBREAKPOINTS_THRESHOLDS.FINAL_MD_MAX + 'px',
    LG_MIN: GDBREAKPOINTS_THRESHOLDS.FINAL_LG_MIN + 'px',
    EXPAND_SCORES_PANEL: GDBREAKPOINTS_THRESHOLDS.LG_MIN + 'px'
};

export const GDBREAKPOINTS_FINAL_MINI = {
    SM_MAX: GDBREAKPOINTS_THRESHOLDS.FINAL_MINI_SM_MAX + 'px',
    XS_MAX: GDBREAKPOINTS_THRESHOLDS.FINAL_MINI_XS_MAX + 'px'
};

export const GDBREAKPOINTS_LIVE_MINI = {
    XS_MAX: GDBREAKPOINTS_THRESHOLDS.LIVE_MINI_XS_MAX + 'px',
    SM_MAX: GDBREAKPOINTS_THRESHOLDS.LIVE_MINI_SM_MAX + 'px',
    MD_MIN: GDBREAKPOINTS_THRESHOLDS.LIVE_MINI_MD_MIN + 'px'
};

const GDBREAKPOINTS = {
    XS: GDBREAKPOINTS_NUM.XS + 'px',
    SM: GDBREAKPOINTS_NUM.SM + 'px',
    MD: GDBREAKPOINTS_NUM.MD + 'px',
    LG: GDBREAKPOINTS_NUM.LG + 'px',
    XL: GDBREAKPOINTS_NUM.XL + 'px',
    XXL: GDBREAKPOINTS_NUM.XXL + 'px',
    XS_MAX: GDBREAKPOINTS_THRESHOLDS.XS_MAX + 'px',
    SM_MIN: GDBREAKPOINTS_THRESHOLDS.SM_MIN + 'px',
    SM_REG_MAX: GDBREAKPOINTS_THRESHOLDS.SM_REG_MAX + 'px',
    SM_WIDE_MIN: GDBREAKPOINTS_THRESHOLDS.SM_WIDE_MIN + 'px',
    SM_MAX: GDBREAKPOINTS_THRESHOLDS.SM_MAX + 'px',
    MD_MIN: GDBREAKPOINTS_THRESHOLDS.MD_MIN + 'px',
    MD_MAX: GDBREAKPOINTS_THRESHOLDS.MD_MAX + 'px',
    LG_MIN: GDBREAKPOINTS_THRESHOLDS.LG_MIN + 'px',
    LG_MAX: GDBREAKPOINTS_THRESHOLDS.LG_MAX + 'px',
    XL_MIN: GDBREAKPOINTS_THRESHOLDS.XL_MIN + 'px',
    XL_MAX: GDBREAKPOINTS_THRESHOLDS.XL_MAX + 'px',
    XXL_MIN: GDBREAKPOINTS_THRESHOLDS.XXL_MIN + 'px'
};

const GAME_CONTEXT_THRESHOLDS = {
    '3XL': {
        min: 1600
    },
    XXL: {
        min: 1360,
        max: 1599
    },
    XL: {
        min: 1280,
        max: 1359
    },
    LG: {
        min: 1024,
        max: 1279
    },
    MD: {
        min: 640,
        max: 1023
    },
    SM: {
        max: 639
    }
};

/*
* breakpoint for mobile || desktop tokens
* <= 768px -> MOBILE
* > 768px -> DESKTOP
*/
const GAME_CONTEXT_MOBILE = 768;
const GAME_CONTEXT_DESKTOP = 769;

export const GAME_CONTEXT_BREAKPOINTS = {
    '3XL_MIN': GAME_CONTEXT_THRESHOLDS['3XL'].min + 'px',
    XXL_MAX: GAME_CONTEXT_THRESHOLDS.XXL.max + 'px',
    XXL_MIN: GAME_CONTEXT_THRESHOLDS.XXL.min + 'px',
    XL_MAX: GAME_CONTEXT_THRESHOLDS.XL.max + 'px',
    XL_MIN: GAME_CONTEXT_THRESHOLDS.XL.min + 'px',
    LG_MAX: GAME_CONTEXT_THRESHOLDS.LG.max + 'px',
    LG_MIN: GAME_CONTEXT_THRESHOLDS.LG.min + 'px',
    MD_MAX: GAME_CONTEXT_THRESHOLDS.MD.max + 'px',
    MD_MIN: GAME_CONTEXT_THRESHOLDS.MD.min + 'px',
    SM_MAX: GAME_CONTEXT_THRESHOLDS.SM.max + 'px',
    MOBILE: GAME_CONTEXT_MOBILE + 'px',
    DESKTOP: GAME_CONTEXT_DESKTOP + 'px'

};

export default GDBREAKPOINTS;
